





















































































































import { Component, Vue } from "vue-property-decorator";
import { SurveyType, Product, SurveyStatusType } from "@/interfaces";

import { SurveyModule } from "@/store";
import { getChannels, deleteChannel } from "@/services";

import { date } from "quasar";
import { notifyError, notifySuccess } from "@/common/notify";

@Component
export default class PromotionsChannelPositioning extends Vue {
  @SurveyModule.bindings.Mutation
  setSurveyType!: (type: SurveyType | null) => void;

  elementsList: Product[] = [];

  loading = false;

  filteredData: Product[] = [];

  searchText = "";

  async mounted() {
    try {
      this.elementsList = await getChannels();
      this.setSurveyType(SurveyType.ANALYSIS_POSITIONING);
      this.filteredData = this.elementsList;
    } catch (error) {
      console.log(error);
    }
  }

  dataSearchSubmit() {
    if (this.searchText.trim() !== "") {
      this.filteredData = this.elementsList.filter(elements =>
        elements.name.toLowerCase().includes(this.searchText.toLowerCase()),
      );
    } else {
      this.filteredData = this.elementsList;
    }
  }

  goToSurvey() {
    this.$router.push(`survey/${SurveyType.ANALYSIS_POSITIONING}`).catch(error => console.log(error));
  }

  openShowElements(elements: Product) {
    this.$router
      .push(`survey/${SurveyType.ANALYSIS_POSITIONING}/${elements.surveys[0].id}`)
      .catch(error => console.log(error));
  }

  getElementsDate(elements: Product) {
    if (elements.surveys.length > 0) {
      return date.formatDate(elements.surveys[0].updated_at, "DD/MM/YYYY HH:mm");
    }

    return "";
  }

  onDeleteElement(element: Product) {
    this.$q
      .dialog({
        title: "Attenzione",
        message: `Sei sicuro di volere eliminare il canale <strong>${element.name}</strong>`,
        html: true,
        cancel: true,
      })
      .onOk(() => {
        this.deleteElementAction(element);
      });
  }

  async deleteElementAction(element: Product) {
    try {
      await deleteChannel(element.id);
      this.elementsList = await getChannels();
      this.filteredData = this.elementsList;
      this.searchText = "";
      notifySuccess("Canale rimosso con successo!");
    } catch (error) {
      console.log(error);
      notifyError("Errore imprevisto, non è stato possibile eliminare il Canale!");
    }
  }

  get statusLabelClass() {
    return (status: SurveyStatusType) => {
      switch (status) {
        case SurveyStatusType.COMPLETED:
          return "text-positive";
        case SurveyStatusType.IN_PROGRESS:
          return "text-warning";
        default:
          return "";
      }
    };
  }

  get statusLabel() {
    return (status: SurveyStatusType) => {
      switch (status) {
        case SurveyStatusType.COMPLETED:
          return "Completato";
        case SurveyStatusType.IN_PROGRESS:
          return "Da Completare";
        default:
          return "Indefinito";
      }
    };
  }

  get columns() {
    return [
      {
        name: "name",
        label: "Nome",
        field: "name",
        align: "left",
        sortable: true,
      },
      {
        name: "status",
        label: "Stato",
        field: (row: Product) => (row.surveys.length > 0 ? this.statusLabel(row.surveys[0].status) : ""),
        align: "left",
        sortable: true,
      },
      {
        label: "Ultima modifica",
        name: "date",
        field: (row: Product) =>
          row.surveys.length > 0 ? date.formatDate(row.surveys[0].updated_at, "DD/MM/YYYY HH:mm") : "",
        align: "left",
        sortable: true,
      },
      { name: "edit", align: "center" },
      { name: "complete", align: "center" },
      { name: "delete", align: "center" },
    ];
  }
}
